import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ModalWindow, Input, useLocalizeMessage } from 'libs.nucleus';
export const PasswordReauthModal = ({ isOpen, email, onSubmit, onCancel, isLoading, error, defaultPrintedName = '', title, heading, subheading, }) => {
    const translate = useLocalizeMessage();
    const [password, setPassword] = useState('');
    const [printedName, setPrintedName] = useState(defaultPrintedName);
    const handleSubmit = async () => {
        await onSubmit(password, printedName);
    };
    const handleCancel = () => {
        setPassword('');
        setPrintedName(defaultPrintedName);
        onCancel();
    };
    const handleKeyUp = (e) => {
        if (e.key === 'Enter' && !isSubmitDisabled && !isLoading) {
            e.preventDefault();
            handleSubmit();
        }
    };
    const isSubmitDisabled = !password || !printedName.trim();
    return (_jsx(ModalWindow, { title: title || translate('Review'), isOpen: isOpen, closeWindow: handleCancel, width: 'full', footerSecondaryActionButtons: [
            {
                label: translate('Cancel'),
                onClick: handleCancel,
                disabled: isLoading,
            },
        ], footerPrimaryActionButton: {
            label: isLoading ? translate('Signing...') : translate('Sign'),
            onClick: handleSubmit,
            variant: 'primary',
            disabled: isSubmitDisabled || isLoading,
        }, dataTestId: 'password-reauth-modal', children: _jsx("div", { className: 'flex justify-center', children: _jsxs("div", { className: 'w-full max-w-lg p-6 space-y-4', onKeyUp: handleKeyUp, children: [heading && _jsx("h3", { className: 'text-lg font-semibold mb-4', children: heading }), subheading && _jsx("p", { className: 'text-sm text-gray-600', children: subheading }), error && (_jsx("div", { className: 'text-red-600 text-sm', role: 'alert', children: error })), _jsx(Input, { id: 'reauth-printed-name', label: translate('Printed name'), value: printedName, onChange: (e) => setPrintedName(e.target.value), width: 'full', autoFocus: true, required: true }), _jsx(Input, { id: 'reauth-email', label: translate('Email'), value: email, width: 'full', disabled: true }), _jsx(Input, { id: 'reauth-password', type: 'password', width: 'full', label: translate('Password'), value: password, onChange: (e) => setPassword(e.target.value), required: true })] }) }) }));
};
